import type { LucideIcon } from "lucide-react";

import {
  IntegrationCardShell,
  StatusPill,
} from "@/components/dashboard/IntegrationCardShell";

interface IntegrationCardProps {
  name: string;
  description: string;
  icon: LucideIcon;
  status: "connected" | "coming_soon";
}

export function IntegrationCard({ name, description, icon, status }: IntegrationCardProps) {
  return (
    <IntegrationCardShell
      icon={icon}
      title={name}
      pill={
        status === "connected" ? (
          <StatusPill variant="active">Connected</StatusPill>
        ) : (
          <StatusPill variant="muted">Coming soon</StatusPill>
        )
      }
      description={description}
    />
  );
}
